import { BuyerOrderFilterType } from "definitions/poizon-api";

export const OrderFilterStatus: Record<string, BuyerOrderFilterType> = {
  ALL: BuyerOrderFilterType._4,
  WAITING_PAYMENT: BuyerOrderFilterType._1,
  WAITING_SENDING: BuyerOrderFilterType._2,
  ACCEPTED: BuyerOrderFilterType._3,
  STATUS_ONE: BuyerOrderFilterType._5,
} as const;

interface IOrderFilterStatus {
  caption: string;
  value: string;
  index: number;
}
interface IROrderFilterStatus {
  label: string;
  value: BuyerOrderFilterType;
}

export const OrderFilterStatusOptions: IROrderFilterStatus[] = [
  {
    label: "Все заказы",
    value: OrderFilterStatus.ALL,
  },
  {
    label: "Ожидают оплаты",
    value: OrderFilterStatus.WAITING_PAYMENT,
  },
  {
    label: "Ожидают отправки",
    value: OrderFilterStatus.WAITING_SENDING,
  },
  {
    label: "Принято",
    value: OrderFilterStatus.ACCEPTED,
  },
];

export const OrderFilterStatuses: IOrderFilterStatus[] = [
  {
    caption: "Все заказы",
    value: "all",
    index: 4,
  },
  {
    caption: "Ожидает оплаты",
    value: "waiting_payment",
    index: 1,
  },
  {
    caption: "Ожидает отправки",
    value: "waiting_sending",
    index: 2,
  },
  {
    caption: "Приняты",
    value: "accepted",
    index: 3,
  },
];
